<template>
    <div v-if="model.app.id">
        {{viewName}}
    </div>
</template>

<script>
    export default {
        name: 'ViewNameDisplay',
        props: ['viewId'],
        computed: {
            viewName() {
                let view = webase.managers.app.getView(this.viewId)
                return view.name
            }
        },
        data () {
            return {
                model: webase.model
            }
        },
        mounted () {
        },
        methods: {
            importantMethodHere () {
            }
        }
    }
</script>

<style>

</style>
